import * as React from "react";
import * as Cookies from 'js-cookie';
import {withRouter} from 'react-router';
import {compose} from "recompose";

import {UserContext, withFirebase} from './index';
import Firebase from "./firebase";
import {IUser} from '../../model/User';

import Constants from '../../constants';


interface IProps {
  firebase: Firebase;
  history: any;
}

interface IState {
  user: IUser;
}

export const withUser = (Component: any) => {

  class WithUser extends React.Component<IProps, IState> {

    constructor(props: IProps) {
      super(props);
      this.state = {
        user: {
          courses: [],
        },
      }
    }

    public componentDidMount(): void {
      const uid = Cookies.get(Constants.uid);
      if (!uid) {return;}

      this.getUser(uid);
      this.getUserSecureData(uid);
    }

    getUser(uid: string) {
      this.props.firebase.users.doc(uid).onSnapshot((doc) => {
        if (doc.exists) {
          const data = doc.data();
          if (data) {
            this.setState({
              user: {
                ...this.state.user,
                courses: data.courses
              },
            })
          }
        }
      }, (error) => {
        //
      });
    }

    getUserSecureData(uid: string) {
      this.props.firebase.users.doc(uid).collection('info').doc('secureData')
        .onSnapshot((doc) => {
          if (doc.exists) {
            const data = doc.data();
            if (data) {
              this.setState({
                user: {
                  ...this.state.user,
                  secureData: {
                    email: data.email,
                    rating: data.rating
                  }
                }
              });
            }
          }
        }, (error => {
          // console.log(error);
        }))
    }

    public render() {
      const { user } = this.state;

      return (
        <UserContext.Provider value={user}>
          <Component {...this.props}/>
        </UserContext.Provider>
      )
    }

  }

  return compose(
    withRouter,
    withFirebase
  )(WithUser)
};

export default withUser;

